<template>
	<svg
		width="200"
		height="100"
		viewBox="0 0 200 100"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="200" height="33" fill="white" />
		<rect y="66" width="200" height="34" fill="white" />
		<rect y="33" width="200" height="33" fill="#0083D6" />
	</svg>
</template>

<script>
export default {
	name: "Russia",
};
</script>
